import React from "react";

// Files Import
import StyledSmText from "../../common/components/styledSmText/StyledSmText";

const Copyrights = () => {
  const currentYear = new Date().getFullYear();
  return (
    <StyledSmText className="text-xs font-normal text-center text-black py-2">
      &#169; {currentYear} Golden Year. All Rights Reserved.
    </StyledSmText>
  );
};

export default Copyrights;
